import { render, staticRenderFns } from "./StoreList.vue?vue&type=template&id=52530a18&scoped=true&"
import script from "./StoreList.vue?vue&type=script&lang=js&"
export * from "./StoreList.vue?vue&type=script&lang=js&"
import style0 from "./StoreList.vue?vue&type=style&index=0&id=52530a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52530a18",
  null
  
)

export default component.exports